import React, { useEffect } from "react";
import AppBody from "../components/AppBody";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllTrainingDetails,
  getAllTrainings,
} from "../../actions/learning_provider/training_action";

const ShowTrainingDetails = () => {
  const state = useSelector((state) => state.trainingReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { slug } = useParams();
  useEffect(() => {
    if (state.trainingDetails.length == 0) {
      dispatch(getAllTrainingDetails({ slug: slug }));
    }
  }, []);

  const playRecordingMeeting = (id) => {
    navigate("/recording/" + btoa(id));
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <span
                onClick={() => navigate(-1)}
                className="d-inline-block mt-2"
              >
                <i className="ti-arrow-left font-sm text-white"></i>
              </span>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Training Details
              </h4>
            </div>
            <div className="card-body p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Trainer Name</th>
                      <th>Topic Name</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>No Of Participants</th>
                      {/* <th>Description</th>*/}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list
                        .filter((li) => li.status === 1)
                        .map((li, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{li.name}</td>
                            <td>{li.start_date}</td>
                            <td>{li.start_date}</td>
                            <td>{li.end_date}</td>
                            <td>
                              {li.is_public === 0 ? "Not Public" : "Public"}
                            </td>
                            <td>
                              <a
                                className="line-height-36 custom-icon mr-2"
                                value={"Play Recording"}
                                title="Play Recording"
                                onClick={() => playRecordingMeeting(li.id)}
                              >
                                <i className="feather-play-circle"></i>
                              </a>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ShowTrainingDetails;
